// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_7mXiG clearfix","list":"index_list_18aUE"};